import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = {
  key: 0,
  class: "badge bg-danger"
}
const _hoisted_9 = {
  key: 1,
  class: "badge bg-warning"
}
const _hoisted_10 = {
  key: 2,
  class: "badge bg-info"
}
const _hoisted_11 = {
  key: 3,
  class: "badge bg-secondary"
}
const _hoisted_12 = {
  key: 4,
  class: "text-muted"
}
const _hoisted_13 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_14 = {
  key: 1,
  class: "badge bg-secondary"
}
const _hoisted_15 = { class: "text-end pe-0" }
const _hoisted_16 = { class: "dropdown" }
const _hoisted_17 = { class: "dropdown-menu" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "pagination-area d-md-flex mt-15 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
          to: "/ajouter-ProduitRestreint"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1),
            _createTextVNode(" Ajouter une produit restreint ", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "search-box position-relative me-15",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "mot",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher par type de restriction"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("button", {
            type: "submit",
            class: "bg-transparent text-primary transition p-0 border-0"
          }, [
            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
          ], -1))
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Type de restriction"),
              _createElementVNode("th", null, "Hs Code"),
              _createElementVNode("th", null, "Catégorie de produit"),
              _createElementVNode("th", null, "Pays"),
              _createElementVNode("th", null, "Régime douanier"),
              _createElementVNode("th", null, "Type de Document"),
              _createElementVNode("th", null, "Statut"),
              _createElementVNode("th", { class: "text-end" }, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prodRestreints, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  (item.restriction_type === 'FORBIDDEN')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Interdit"))
                    : (item.restriction_type === 'LICENSE_REQUIRED')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Licence requise"))
                      : (item.restriction_type === 'SPECIAL_TAX')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Taxe spéciale"))
                        : (item.restriction_type === 'QUOTA_LIMITED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Quantité limitée"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
                ]),
                _createElementVNode("td", null, _toDisplayString(item.hscode?.product || '-'), 1),
                _createElementVNode("td", null, _toDisplayString(item.categorieProduit?.name || '-'), 1),
                _createElementVNode("td", null, _toDisplayString(item.pays?.name_fr || '-'), 1),
                _createElementVNode("td", null, _toDisplayString(item.regimedouanier?.name || '-'), 1),
                _createElementVNode("td", null, _toDisplayString(item.typeD?.libelle || '-'), 1),
                _createElementVNode("td", null, [
                  (item.is_active)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Actif"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, "Inactif"))
                ]),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", {
                      class: "badge text-white bg-primary fs-15 dropdown-toggle",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createTextVNode(" Actions "),
                      _createElementVNode("i", { class: "flaticon-chevron-2 ms-5 fs-15" })
                    ], -1)),
                    _createElementVNode("ul", _hoisted_17, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'EditProduitRestreintPage', params: { id: item.id } },
                          class: "dropdown-item d-flex align-items-center"
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode("Modifier", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item d-flex align-items-center",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.suppression(item.id, _ctx.prodRestreints, 'restricted', 'restricted'))
                        }, [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("i", { class: "flaticon-delete me-8" }, null, -1),
                          _createTextVNode(" Supprimer ", -1)
                        ]))], 8, _hoisted_18)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}